import { useQuery } from 'react-query';
import { MeResponse } from './userTypes';
import { getMe } from './userService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: MeResponse) => void;
    mapper?: (data?: MeResponse) => M | MeResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: MeResponse) => data;

export const useGetMe = <M = MeResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<MeResponse, Error>(['me'], getMe, {
        onSuccess,
        onError,
        enabled: enabled,
    });

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
